import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ACCESSTOKEN, http, settings } from "../../utils/config";

const initialState = {
  token: null,
  isLoading: false,
  sendoStatus: null,
  isLoadStatus: false,
};

export const conect = createAsyncThunk("connectSendo/conect", async (data) => {
  try {
    const response = await http.post("/connect-sendo", data);
    return response.data;
  } catch (error) {
    throw new Error("Có lỗi xảy ra trong quá trình kết nối");
  }
});

export const getSendoStatus = createAsyncThunk(
  "connectSendo/getSendoStatus",
  async () => {
    const response = await http.get("/status-sendo");
    return response.data.data;
  }
);

export const postSendoDisconnect = createAsyncThunk(
  "connectSendo/postSendoDisconnect",
  async () => {
    const response = await http.post("/disconnect-sendo");
    return response.data;
  }
);

const connectSendo = createSlice({
  name: "connectSendo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(conect.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(conect.fulfilled, (state, action) => {
        state.isLoading = false;
        state.token = action.payload;
        settings.setCookie(
          ACCESSTOKEN,
          action.payload.data.access_token,
          1 / 4
        );
      })
      .addCase(conect.rejected, (state, action) => {
        state.isLoading = false;
      })
      // Status
      .addCase(getSendoStatus.pending, (state) => {
        state.isLoadStatus = true;
      })
      .addCase(getSendoStatus.fulfilled, (state, action) => {
        state.sendoStatus = action.payload;
        state.isLoadStatus = false;
      })
      .addCase(getSendoStatus.rejected, (state) => {
        state.sendoStatus = null;
        state.isLoadStatus = false;
      });
  },
});

export default connectSendo.reducer;
